var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoftware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 827,
    height: 905,
    viewBox: "0 0 827 905",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M259.785 668.815C267.75 668.815 274.208 660.814 274.208 650.946C274.208 641.077 267.75 633.077 259.785 633.077C251.819 633.077 245.362 641.077 245.362 650.946C245.362 660.814 251.819 668.815 259.785 668.815Z",
    fill: "#B5A8AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M632.829 655.958C642.025 655.958 649.48 646.722 649.48 635.329C649.48 623.936 642.025 614.7 632.829 614.7C623.634 614.7 616.179 623.936 616.179 635.329C616.179 646.722 623.634 655.958 632.829 655.958Z",
    fill: "url(#paint0_linear_1348_3000)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.403 596.399H379.374C372.281 596.399 366.529 589.354 366.529 580.663V530.144C366.529 522.007 371.573 515.311 378.039 514.493C377.893 514.489 377.75 514.467 377.603 514.467H375.445C367.893 514.467 361.771 521.965 361.771 531.218V584.998C361.771 594.25 367.893 601.748 375.445 601.748H377.603C380.12 601.755 382.589 600.901 384.739 599.281C386.889 597.661 388.637 595.337 389.79 592.566C387.454 595.044 384.479 596.403 381.403 596.399Z",
    fill: "#E3DDE4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M429.302 637.307C429.302 637.307 419.402 589.397 415.267 553.934C411.669 523.068 407.35 481.552 407.35 481.552H377.604V481.571L377.596 481.552H347.851C347.851 481.552 343.533 523.068 339.934 553.932C335.8 589.398 325.901 637.308 325.901 637.308H377.596L377.604 637.288V637.308L429.302 637.307ZM375.446 601.748C367.894 601.748 361.772 594.249 361.772 584.998V531.216C361.772 521.963 367.894 514.466 375.446 514.466H377.604C385.157 514.466 391.278 521.963 391.278 531.216V584.995C391.278 594.249 385.157 601.746 377.604 601.746H375.446V601.748Z",
    fill: "url(#paint1_linear_1348_3000)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.372 466.287V176.114C567.372 167.77 561.905 161.005 555.161 161.005H282.257C279.01 168.601 274.13 175.009 266.018 179.054C240.833 191.61 219.294 190.704 192.924 191.678V466.287H567.372Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.371 176.114C567.371 167.77 561.905 161.005 555.161 161.005H521.992L520.353 165.379C522.984 176.666 521.054 186.216 507.841 191.209C488.739 198.424 454.299 191.914 447.151 219.714C442.24 238.814 449.139 257.481 455.687 266.164C462.236 274.846 470.186 291.631 454.284 295.683C438.381 299.736 418.265 290.545 404.238 289.027C382.837 286.711 353.955 285.987 340.507 311.599C330.558 330.548 338.169 348.643 349.335 351.175C357.852 353.107 366.934 348.138 370.384 338.153C373.564 328.949 369.746 320.889 364.245 319.488C358.574 318.039 353.211 322.811 352.084 327.23C351.032 331.352 352.998 333.533 355.124 333.306C358.514 332.944 359.978 329.255 361.321 330.99C363.042 333.213 360.473 338.696 355.475 339.818C351.707 340.664 346.968 339.564 345.886 331.135C344.872 323.232 348.108 316.014 355.592 311.89C362.536 308.063 370.794 309.864 375.94 318.836C381.085 327.808 379.506 343.362 372.665 351.103C362.454 362.661 349.844 364.109 330.334 369.77C305.417 376.999 267.423 388.508 261.81 424.466C258.494 445.704 266.733 458.79 274.711 466.286H567.371V176.114Z",
    fill: "url(#paint2_linear_1348_3000)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M422.478 437.781C438.153 433.443 466.913 425.194 475.099 393.286C482.644 363.875 462.994 359.667 464.574 335.622C465.977 314.278 498.6 306.005 530.058 297.711C561.888 289.317 556.719 270.505 554.848 261.246C554.848 261.246 550.54 236.292 567.371 227.397V180.628L564.203 178.839C563.502 184.917 546.522 206.751 528.619 207.516C510.647 208.286 485.273 201.628 472.468 222.465C462.303 239.008 471.591 257.34 477.378 266.528C481.285 272.732 487.3 295.253 470.011 301.039C448.611 308.2 429.117 298.826 415.286 295.614C398.155 291.633 385.292 298.291 383.011 306.683C379.153 320.88 395.027 324.359 394.062 343.364C393.243 359.498 371.206 373.499 339.863 379.179C304.723 385.546 291.415 401.76 290.925 421.142C290.456 439.663 301.274 448.635 314.429 450.154C327.027 451.611 343.31 448.105 344.209 466.288H392.433C387.781 440.136 409.302 441.43 422.478 437.781Z",
    fill: "url(#paint3_linear_1348_3000)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M494.744 354.143C488.956 371.144 508.251 375.27 504.333 407.683C500.849 436.501 461.066 432.571 448.204 442.123C440.537 447.816 439.601 458.545 440.097 466.287H567.372V335.381C552.901 346.472 502.176 332.314 494.744 354.143Z",
    fill: "url(#paint4_linear_1348_3000)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M554.848 261.245C556.72 270.505 561.888 289.317 530.058 297.71C498.6 306.004 465.977 314.279 464.574 335.622C462.993 359.668 482.644 363.875 475.099 393.285C466.913 425.191 438.153 433.442 422.477 437.781C409.302 441.429 387.782 440.135 392.433 466.288H440.096C439.601 458.545 440.536 447.816 448.204 442.122C461.066 432.573 500.848 436.503 504.332 407.682C508.249 375.27 488.956 371.145 494.743 354.144C502.176 332.314 552.902 346.472 567.371 335.381V227.399C550.541 236.292 554.849 261.245 554.849 261.245H554.848Z",
    fill: "url(#paint5_linear_1348_3000)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M536.489 227.239C531.928 233.317 524.094 235.632 516.378 236.934C508.661 238.235 494.861 239.973 488.254 254.587C481.684 269.124 487.836 290.96 501.585 292.354C520.12 294.236 524.914 273.399 529.825 266.96C534.295 261.097 544.208 258.061 544.384 248.728C544.559 239.394 536.489 227.239 536.489 227.239Z",
    fill: "url(#paint6_linear_1348_3000)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.163 407.104C397.965 409.737 415.228 406.903 420.84 397.844C426.219 389.161 423.18 378.742 427.856 373.243C432.532 367.745 451.378 351.782 454.984 342.855C458.258 334.752 455.686 324.334 448.203 321.151C440.958 318.069 434.638 322.018 431.364 330.123C428.089 338.227 425.05 350.38 412.42 359.352C401.879 366.84 378.137 374.872 374.767 388.292C372.079 399.001 379.445 405.222 387.163 407.104Z",
    fill: "url(#paint7_linear_1348_3000)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M555.452 169.688C557.368 169.688 558.929 171.17 558.929 172.993V466.433H571.711V172.993C571.711 164.454 564.432 157.532 555.452 157.532H196.75C194.712 161.971 192.102 166.09 188.558 169.688H555.452Z",
    fill: "#93778B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.407 466.432V157.967C195.203 158.077 191.934 158.205 188.584 158.374V466.432H198.407Z",
    fill: "#93778B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.584 464.115V480.49C188.584 489.027 194.177 495.95 201.078 495.95H559.219C566.118 495.95 571.712 489.027 571.712 480.49V464.115H188.584Z",
    fill: "url(#paint8_linear_1348_3000)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.372 307.067C333.372 307.524 333.3 307.976 333.159 308.398C333.018 308.819 332.811 309.202 332.55 309.525C332.29 309.848 331.98 310.103 331.64 310.278C331.299 310.452 330.934 310.541 330.566 310.541H222.168C221.424 310.541 220.711 310.176 220.184 309.524C219.658 308.873 219.362 307.989 219.362 307.067V254.107C219.362 252.189 220.617 250.633 222.168 250.633H330.567C330.935 250.633 331.3 250.723 331.641 250.897C331.981 251.071 332.29 251.327 332.551 251.65C332.812 251.972 333.018 252.355 333.159 252.777C333.301 253.198 333.373 253.65 333.373 254.107V307.067H333.372Z",
    fill: "#E3DDE4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M330.566 311.842H222.168C221.146 311.842 220.166 311.339 219.442 310.444C218.719 309.549 218.312 308.335 218.31 307.068V254.107C218.31 251.473 220.041 249.333 222.168 249.333H330.567C331.589 249.333 332.57 249.836 333.294 250.731C334.017 251.626 334.425 252.841 334.427 254.107V307.068C334.427 309.702 332.695 311.842 330.567 311.842H330.566ZM222.168 251.939C221.202 251.939 220.415 252.912 220.415 254.109V307.069C220.415 308.266 221.2 309.241 222.168 309.241H330.567C331.535 309.241 332.321 308.267 332.321 307.069V254.107C332.321 253.532 332.136 252.98 331.807 252.573C331.478 252.166 331.033 251.937 330.568 251.937H222.166L222.168 251.939Z",
    fill: "#B5A8AE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.026 268.323H321.533C321.735 268.336 321.937 268.298 322.128 268.212C322.318 268.125 322.491 267.992 322.638 267.819C322.785 267.647 322.902 267.439 322.982 267.208C323.062 266.978 323.104 266.729 323.104 266.479C323.104 266.228 323.062 265.979 322.982 265.749C322.902 265.518 322.785 265.311 322.638 265.138C322.491 264.965 322.318 264.832 322.128 264.745C321.937 264.659 321.735 264.621 321.533 264.635H231.026C230.824 264.621 230.621 264.659 230.431 264.745C230.241 264.832 230.067 264.965 229.92 265.138C229.773 265.311 229.656 265.518 229.576 265.749C229.496 265.979 229.455 266.228 229.455 266.479C229.455 266.729 229.496 266.978 229.576 267.208C229.656 267.439 229.773 267.647 229.92 267.819C230.067 267.992 230.241 268.125 230.431 268.212C230.621 268.298 230.824 268.336 231.026 268.323ZM231.026 282.432H274.758C274.958 282.442 275.158 282.401 275.345 282.313C275.533 282.224 275.704 282.09 275.848 281.918C275.992 281.745 276.107 281.539 276.186 281.31C276.264 281.081 276.305 280.836 276.305 280.587C276.305 280.339 276.264 280.093 276.186 279.864C276.107 279.636 275.992 279.429 275.848 279.257C275.704 279.084 275.533 278.95 275.345 278.861C275.158 278.773 274.958 278.732 274.758 278.742H231.026C230.825 278.732 230.626 278.773 230.438 278.861C230.251 278.95 230.08 279.084 229.935 279.257C229.791 279.429 229.676 279.636 229.598 279.864C229.519 280.093 229.479 280.339 229.479 280.587C229.479 280.836 229.519 281.081 229.598 281.31C229.676 281.539 229.791 281.745 229.935 281.918C230.08 282.09 230.251 282.224 230.438 282.313C230.626 282.401 230.825 282.442 231.026 282.432ZM321.533 278.743H304.109C303.909 278.734 303.709 278.774 303.521 278.863C303.334 278.951 303.163 279.086 303.019 279.258C302.874 279.43 302.759 279.637 302.681 279.865C302.602 280.094 302.562 280.34 302.562 280.588C302.562 280.837 302.602 281.083 302.681 281.311C302.759 281.54 302.874 281.747 303.019 281.919C303.163 282.091 303.334 282.226 303.521 282.314C303.709 282.403 303.909 282.443 304.109 282.434H321.533C321.733 282.443 321.933 282.403 322.121 282.314C322.308 282.226 322.479 282.091 322.623 281.919C322.768 281.747 322.883 281.54 322.961 281.311C323.04 281.083 323.08 280.837 323.08 280.588C323.08 280.34 323.04 280.094 322.961 279.865C322.883 279.637 322.768 279.43 322.623 279.258C322.479 279.086 322.308 278.951 322.121 278.863C321.933 278.774 321.733 278.734 321.533 278.743ZM296.128 280.588C296.128 279.569 295.461 278.743 294.638 278.743H284.347C284.147 278.734 283.947 278.774 283.759 278.863C283.572 278.951 283.401 279.086 283.257 279.258C283.112 279.43 282.997 279.637 282.919 279.865C282.84 280.094 282.8 280.34 282.8 280.588C282.8 280.837 282.84 281.083 282.919 281.311C282.997 281.54 283.112 281.747 283.257 281.919C283.401 282.091 283.572 282.226 283.759 282.314C283.947 282.403 284.147 282.443 284.347 282.434H294.636C295.46 282.434 296.128 281.608 296.128 280.588ZM305.045 292.852H294.756C294.555 292.842 294.355 292.883 294.168 292.971C293.981 293.06 293.81 293.194 293.665 293.366C293.521 293.539 293.406 293.745 293.327 293.974C293.249 294.203 293.208 294.449 293.208 294.697C293.208 294.945 293.249 295.191 293.327 295.42C293.406 295.648 293.521 295.855 293.665 296.027C293.81 296.2 293.981 296.334 294.168 296.423C294.355 296.511 294.555 296.552 294.756 296.542H305.045C305.44 296.542 305.819 296.348 306.098 296.002C306.377 295.656 306.534 295.186 306.534 294.697C306.534 294.208 306.377 293.738 306.098 293.392C305.819 293.046 305.44 292.852 305.045 292.852ZM283.909 292.852H231.027C230.826 292.842 230.627 292.883 230.439 292.971C230.252 293.06 230.081 293.194 229.936 293.366C229.792 293.539 229.677 293.745 229.599 293.974C229.52 294.203 229.48 294.449 229.48 294.697C229.48 294.945 229.52 295.191 229.599 295.42C229.677 295.648 229.792 295.855 229.936 296.027C230.081 296.2 230.252 296.334 230.439 296.423C230.627 296.511 230.826 296.552 231.027 296.542H283.909C284.109 296.552 284.309 296.511 284.496 296.423C284.683 296.334 284.854 296.2 284.999 296.027C285.143 295.855 285.258 295.648 285.337 295.42C285.415 295.191 285.456 294.945 285.456 294.697C285.456 294.449 285.415 294.203 285.337 293.974C285.258 293.745 285.143 293.539 284.999 293.366C284.854 293.194 284.683 293.06 284.496 292.971C284.309 292.883 284.109 292.842 283.909 292.852Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.014 217.152L324.016 218.99L283.718 251.407L282.717 249.57L323.014 217.152ZM251.618 409.83L250.016 408.141L290.471 349.547L252.031 311.607L253.344 309.569L293.485 349.19L251.618 409.83Z",
    fill: "#B5A8AE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.333 419.838H421.074V422.442H272.333V419.838Z",
    fill: "#93778B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284.26 422.009C284.26 428.243 280.176 433.296 275.139 433.296H228.481C223.444 433.296 219.361 428.243 219.361 422.009V420.273C219.361 414.039 223.444 408.986 228.481 408.986H275.14C280.177 408.986 284.259 414.041 284.259 420.273L284.26 422.009Z",
    fill: "#BE4118"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M275.139 434.597H228.481C222.871 434.597 218.307 428.951 218.307 422.008V420.271C218.307 413.329 222.873 407.683 228.481 407.683H275.14C280.748 407.683 285.312 413.331 285.312 420.271V422.008C285.312 428.949 280.748 434.597 275.139 434.597ZM228.481 410.286C224.033 410.286 220.412 414.766 220.412 420.271V422.008C220.412 427.513 224.033 431.992 228.481 431.992H275.14C279.588 431.992 283.207 427.513 283.207 422.008V420.271C283.207 414.766 279.587 410.286 275.139 410.286H228.481Z",
    fill: "#B5A8AE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.17 422.009C376.17 428.243 372.088 433.296 367.049 433.296H320.393C315.354 433.296 311.272 428.243 311.272 422.009V420.273C311.272 414.039 315.355 408.986 320.393 408.986H367.049C372.088 408.986 376.17 414.041 376.17 420.273V422.009Z",
    fill: "#5C60D5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M367.05 434.597H320.394C314.784 434.597 310.22 428.951 310.22 422.008V420.271C310.22 413.329 314.785 407.683 320.394 407.683H367.05C372.66 407.683 377.224 413.331 377.224 420.271V422.008C377.224 428.949 372.66 434.597 367.05 434.597ZM320.394 410.286C315.943 410.286 312.325 414.766 312.325 420.271V422.008C312.325 427.513 315.944 431.992 320.394 431.992H367.05C371.498 431.992 375.119 427.513 375.119 422.008V420.271C375.119 414.766 371.498 410.286 367.05 410.286H320.394Z",
    fill: "#93778B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M291.977 361.813C297.531 361.813 302.034 356.241 302.034 349.368C302.034 342.494 297.531 336.922 291.977 336.922C286.423 336.922 281.92 342.494 281.92 349.368C281.92 356.241 286.423 361.813 291.977 361.813Z",
    fill: "#B5A8AE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M291.977 354.831C294.416 354.831 296.392 352.385 296.392 349.368C296.392 346.35 294.416 343.904 291.977 343.904C289.539 343.904 287.563 346.35 287.563 349.368C287.563 352.385 289.539 354.831 291.977 354.831Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.215 206.715C359.215 213.892 354.514 219.71 348.715 219.71H294.995C289.194 219.71 284.495 213.89 284.495 206.715V204.717C284.495 197.539 289.196 191.721 294.995 191.721H348.715C354.514 191.721 359.215 197.539 359.215 204.717V206.715Z",
    fill: "#5C60D5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M348.714 221.012H294.995C288.624 221.012 283.441 214.598 283.441 206.715V204.717C283.441 196.831 288.625 190.419 294.995 190.419H348.714C355.085 190.419 360.268 196.832 360.268 204.715V206.713C360.268 214.599 355.085 221.012 348.714 221.012ZM294.995 193.023C289.784 193.023 285.546 198.267 285.546 204.715V206.713C285.546 213.163 289.784 218.408 294.995 218.408H348.714C353.924 218.408 358.163 213.163 358.163 206.713V204.715C358.163 198.267 353.924 193.022 348.714 193.022L294.995 193.023Z",
    fill: "#B5A8AE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M487.162 646.199C387.002 602.961 276.392 636.207 230.892 658.212C258.729 677.628 324.663 675.573 349.574 696.611C360.787 706.079 367.378 721.108 372.11 737.932C396.437 747.087 420.022 756.994 438.906 765.806C487.901 788.668 640.289 746.141 674.326 736.169V683.895C639.674 693.586 597.194 693.701 487.16 646.2L487.162 646.199Z",
    fill: "url(#paint9_linear_1348_3000)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M589.18 810.266C594.356 820.611 589.32 831.693 571.972 840.928C557.35 848.713 549.926 862.272 559.658 872.364C559.907 872.623 560.171 872.88 560.444 873.134L560.618 873.293C560.851 873.505 561.091 873.717 561.341 873.925L561.537 874.091C561.819 874.32 562.109 874.548 562.409 874.775C562.442 874.798 562.471 874.822 562.503 874.846C563.184 875.352 563.92 875.847 564.707 876.327L564.968 876.482C565.278 876.666 565.594 876.848 565.917 877.029L566.232 877.202C566.576 877.39 566.931 877.573 567.293 877.756L567.53 877.877C568.004 878.11 568.481 878.335 568.961 878.552C569.417 878.757 569.889 878.957 570.371 879.154L570.775 879.315C571.145 879.464 571.525 879.61 571.911 879.755C572.474 879.964 573.04 880.164 573.607 880.355L574.03 880.5C574.592 880.684 575.163 880.865 575.751 881.042L575.823 881.061C576.378 881.226 576.95 881.387 577.533 881.544C577.718 881.595 577.907 881.642 578.095 881.691C579.216 881.986 580.34 882.255 581.469 882.497L582.079 882.631C583.879 883.012 585.685 883.339 587.497 883.613C587.813 883.663 588.132 883.71 588.452 883.758C589.356 883.892 590.267 884.021 591.187 884.137C591.444 884.171 591.698 884.207 591.956 884.238C593.101 884.379 594.256 884.506 595.421 884.624C595.689 884.651 595.962 884.675 596.231 884.699C597.17 884.789 598.118 884.871 599.07 884.947C599.405 884.973 599.743 885.001 600.079 885.025C601.256 885.111 602.438 885.19 603.629 885.257L603.694 885.26C604.905 885.327 606.126 885.382 607.35 885.43C607.704 885.445 608.06 885.457 608.415 885.47C609.382 885.504 610.35 885.532 611.322 885.556C611.617 885.564 611.91 885.574 612.206 885.579C613.424 885.605 614.647 885.623 615.875 885.635C616.191 885.639 616.506 885.639 616.822 885.642C617.782 885.649 618.743 885.653 619.706 885.652L620.873 885.65C623.349 885.641 625.826 885.612 628.302 885.564L629.646 885.538C630.295 885.524 630.947 885.511 631.598 885.495C681.279 882.812 772.059 851.161 789.996 770.8L790.01 770.797L790.067 770.473C790.248 769.4 790.44 768.323 790.645 767.244C790.794 766.459 790.945 765.671 791.106 764.884C791.471 763.126 791.861 761.375 792.275 759.634C792.671 758.027 793.111 756.437 793.596 754.867C793.901 753.866 794.223 752.868 794.564 751.87C794.65 751.618 794.729 751.364 794.818 751.114C795.188 750.056 795.573 749.006 795.974 747.965L795.984 747.971C802.973 729.874 815.189 712.208 826.532 691.913C792.854 690.204 744.62 671.854 705.602 669.208C705.578 669.204 705.553 669.202 705.529 669.2L705.428 669.192C697.886 668.575 690.327 668.314 682.768 668.408C620.375 669.146 565.538 704.118 545.416 704.676C516.267 705.486 472.373 686.386 422.992 683.924C384.576 682.007 359.446 687.183 342.739 694.014C387.319 720.497 370.762 798.694 414.582 812.247C455.101 824.777 528.148 799.903 545.535 796.965C566.309 793.457 582.813 797.539 589.182 810.266H589.18Z",
    fill: "url(#paint10_linear_1348_3000)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.382 729.181C459.576 725.791 485.341 740.909 503.691 739.838C520.285 738.869 542.167 718.509 558.194 716.91C572.763 715.456 585.328 720.464 585.175 736.61C585.041 750.817 569.256 752.432 559.002 752.11C548.75 751.787 521.614 748.094 513.405 750.494C501.263 754.048 501.88 766.093 490.47 772.13C477.654 778.912 449.729 778.589 427.064 771.485C404.401 764.38 389.844 757.306 390.374 754.047C390.904 750.788 400.488 732.893 431.382 729.181Z",
    fill: "url(#paint11_linear_1348_3000)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M636.014 369.609C639.09 373.27 642.105 377.01 645.056 380.825C648.025 384.613 650.886 388.517 653.861 392.3C656.835 396.084 659.852 399.817 662.514 403.941C663.181 404.97 663.835 406.014 664.474 407.071C665.101 408.144 665.762 409.18 666.303 410.346C666.85 411.503 667.309 412.76 667.674 414.114C668.027 415.488 668.293 416.951 668.316 418.681C666.927 418.437 665.784 417.926 664.726 417.322C663.716 416.729 662.758 416.007 661.868 415.169C660.999 414.36 660.249 413.421 659.466 412.52C658.696 411.605 657.939 410.673 657.195 409.725C654.217 405.948 651.594 401.784 648.926 397.668C646.258 393.551 643.481 389.557 640.809 385.445C638.113 381.353 635.486 377.192 632.93 372.965C632.768 372.697 632.65 372.392 632.584 372.067C632.518 371.743 632.504 371.405 632.543 371.074C632.583 370.743 632.675 370.424 632.814 370.137C632.953 369.85 633.136 369.6 633.354 369.402C633.746 369.043 634.228 368.866 634.715 368.905C635.201 368.943 635.661 369.192 636.014 369.609Z",
    fill: "#EA971D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M660.654 414.774H660.64C660.453 414.774 660.273 414.682 660.141 414.518C660.008 414.355 659.933 414.133 659.932 413.901C659.932 412.986 660.578 411.292 661.662 410.042C662.2 409.407 662.839 408.919 663.539 408.608C664.238 408.298 664.983 408.172 665.724 408.24C665.822 408.241 665.918 408.267 666.008 408.316C666.098 408.365 666.178 408.436 666.245 408.525C666.311 408.614 666.363 408.719 666.396 408.833C666.428 408.947 666.442 409.069 666.436 409.19C666.429 409.311 666.403 409.429 666.358 409.537C666.314 409.645 666.252 409.741 666.176 409.819C666.101 409.896 666.013 409.953 665.919 409.988C665.825 410.022 665.727 410.032 665.629 410.017C665.1 409.964 664.567 410.048 664.065 410.263C663.563 410.478 663.102 410.821 662.713 411.268C661.812 412.268 661.385 413.575 661.375 413.903C661.368 414.135 661.289 414.355 661.155 414.518C661.021 414.68 660.842 414.771 660.654 414.774ZM639.367 373.683C638.256 372.318 637.145 370.953 636.014 369.61C635.661 369.193 635.201 368.943 634.714 368.905C634.227 368.868 633.745 369.044 633.353 369.404C633.136 369.603 632.952 369.853 632.813 370.14C632.674 370.427 632.583 370.745 632.543 371.076C632.504 371.408 632.518 371.745 632.584 372.07C632.65 372.394 632.768 372.699 632.93 372.967C633.887 374.558 634.869 376.125 635.85 377.693C636.428 376.131 637.448 374.432 639.367 373.683ZM668.03 415.78L666.21 418.054C666.894 418.344 667.599 418.553 668.316 418.68C668.301 417.704 668.205 416.732 668.03 415.78Z",
    fill: "#BE4118"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M587.409 683.219C589.78 689.471 602.357 728.54 601.647 731.519C600.936 734.496 569.534 748.182 563.029 745.158C562.18 744.763 562.334 742.224 563.672 741.298C567.081 738.939 583.843 725.943 585.329 721.973C586.69 718.333 573.481 692.411 573.707 692.254C574.427 691.755 587.409 683.219 587.409 683.219Z",
    fill: "#EAAEA4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M600.296 724.505C599.036 719.686 597.063 713.034 595.019 706.442C590.593 711.351 585.686 712.343 582.789 712.484C584.579 716.954 585.789 720.741 585.328 721.973C584.733 723.567 581.678 726.61 578.014 729.839C582.958 730.341 592.383 731.297 592.573 731.297C592.717 731.297 596.712 727.73 600.297 724.505H600.296Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M563.03 745.157C569.537 748.181 600.937 734.495 601.647 731.518C601.849 730.67 600.978 726.91 599.574 721.82C597.331 723.42 595 727.033 593.356 727.996C591.102 729.316 589.079 729.171 585.349 728.29C583.502 727.857 582.131 727.427 580.89 727.217C575.254 732.579 566.095 739.622 563.673 741.299C562.335 742.224 562.181 744.761 563.03 745.157Z",
    fill: "#5B252C"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M524.291 549.431C524.523 556.472 532.386 616.898 535.623 640.364C538.862 663.829 545.395 703.576 547.128 704.236C548.863 704.895 558.23 705.555 575.056 701.155C591.881 696.755 604.197 688.174 604.37 687.296C604.543 686.415 586.742 635.231 577.842 605.739C568.943 576.244 563.433 550.457 563.433 550.457L524.291 549.431Z",
    fill: "url(#paint12_linear_1348_3000)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M542.952 684.45C542.75 684.45 542.562 684.446 542.389 684.436L542.443 682.68C549.189 683.009 580.497 676.073 596.79 664.329L597.476 665.858C581.086 677.67 550.965 684.45 542.952 684.45Z",
    fill: "#5B252C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M544.252 691.405C544.042 691.405 543.845 691.399 543.664 691.389L543.718 689.632C545.133 689.697 547.514 689.471 550.528 688.977L550.705 690.726C547.984 691.169 545.754 691.405 544.252 691.405ZM557.602 689.38L557.364 687.644C559.56 687.156 561.847 686.596 564.161 685.981L564.445 687.703C562.116 688.322 559.813 688.886 557.602 689.38ZM571.242 685.755L570.915 684.045C573.186 683.345 575.439 682.602 577.614 681.832L577.987 683.528C575.749 684.317 573.5 685.06 571.242 685.755ZM584.665 680.988L584.239 679.313C586.432 678.419 588.604 677.45 590.754 676.407L591.251 678.05C589.21 679.044 586.994 680.035 584.665 680.987V680.988ZM597.685 674.548L597.081 672.963C597.876 672.478 598.64 671.981 599.357 671.488L600.018 673.038C599.282 673.542 598.497 674.049 597.686 674.548H597.685Z",
    fill: "#EA971D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M563.184 679.83C562.848 678.33 561.655 673.416 560.005 666.617C553.038 637.909 536.722 570.687 533.899 549.852L535.266 549.555C538.075 570.279 554.372 637.425 561.332 666.099C563.047 673.164 564.18 677.833 564.517 679.354L563.184 679.83Z",
    fill: "#5B252C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.301 706.277C495.768 713.419 489.563 756.477 487.613 758.639C485.663 760.805 443.998 758.208 443.998 754.745C443.998 751.284 446.834 751.284 450.913 750.2C454.99 749.119 474.245 742.726 476.502 739.599C478.758 736.474 479.201 705.093 478.933 705.005C478.667 704.915 496.301 706.277 496.301 706.277Z",
    fill: "#EAAEA4"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.345 727.117C477.951 733.172 477.357 738.413 476.502 739.599C475.485 741.011 471.007 743.082 466.025 745.036L468.111 748.47L477.33 754.311L489.305 752.613C490.446 747.105 491.847 738.629 493.098 730.357C483.109 730.646 480.639 728.493 478.346 727.117H478.345Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.999 754.745C443.999 758.208 485.664 760.805 487.613 758.639C488.173 758.019 489.082 754.036 490.107 748.502C486.809 748.799 483.716 751.643 479.459 751.643C475.181 751.643 471.461 746.96 468.746 743.936C462.162 746.701 453.496 749.518 450.913 750.2C446.835 751.284 443.998 751.284 443.998 754.745H443.999Z",
    fill: "#5B252C"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M481.586 558.067C478.755 564.715 458.361 631.198 453.219 653.268C448.075 675.338 443.998 695.894 445.062 697.624C446.126 699.354 456.055 705.632 472.188 708.658C488.322 711.689 508.761 714.232 511.219 712.958C513.675 711.688 516.928 657.307 521.655 624.132C526.383 590.956 534.185 558.356 534.185 558.356L481.586 558.067Z",
    fill: "url(#paint13_linear_1348_3000)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.952 689.629C481.513 689.629 454.477 676.752 448.756 672.265L449.523 670.808C455.203 675.265 482.285 688.106 514.782 687.894L514.79 689.624C514.511 689.627 514.23 689.629 513.952 689.629Z",
    fill: "#5B252C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.179 683.358C448.743 682.626 447.637 681.958 446.895 681.375L447.662 679.921C448.325 680.44 449.385 681.077 450.726 681.761L450.179 683.36V683.358Z",
    fill: "#EA971D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M503.567 697.014C501.338 696.811 499.048 696.558 496.761 696.254L496.913 694.532C499.185 694.832 501.458 695.086 503.672 695.288L503.567 697.014ZM489.977 695.22C487.722 694.834 485.471 694.405 483.226 693.936L483.465 692.23C485.694 692.697 487.951 693.126 490.175 693.507L489.977 695.22ZM476.509 692.401C474.276 691.849 472.05 691.255 469.831 690.62L470.156 688.936C472.315 689.556 474.547 690.151 476.79 690.706L476.509 692.401ZM463.202 688.57C460.999 687.843 458.81 687.056 456.636 686.208L457.069 684.559C459.085 685.35 461.272 686.137 463.574 686.903L463.202 688.57Z",
    fill: "#EA971D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.954 697.601C512.767 697.576 511.58 697.536 510.394 697.48L510.447 695.751C511.621 695.806 512.8 695.845 513.978 695.869L513.954 697.6V697.601Z",
    fill: "#EA971D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.527 682.917L474.117 682.725C475.13 671.54 488.864 577.059 501.599 557.639L502.706 558.72C490.394 577.502 476.496 672.227 475.527 682.917Z",
    fill: "#5B252C"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M559.211 366.802C558.624 371.002 556.267 384.616 552.499 390.553C548.732 396.493 575.344 392.726 575.344 392.726C575.344 392.726 574.777 375.808 575.463 364.34C575.466 360.841 572.517 358.836 568.22 359.525C563.488 360.284 559.211 366.802 559.211 366.802Z",
    fill: "#E08C7C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M558.535 322.989C556.37 325.107 554.251 329.452 552.264 333.96C550.781 337.323 550.1 338.577 546.701 341.455C544.036 343.71 542.315 344.477 542.195 346.126C542.078 347.756 545.375 349.602 545.464 351.015C545.553 352.427 542.987 365.505 547.495 370.675C550.558 374.189 561.098 374.551 570.424 365.715C578.786 357.794 585.031 338.306 582.028 328.421C579.024 318.536 558.535 322.989 558.535 322.989Z",
    fill: "#EAAEA4"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M564.982 295.073C567.573 296.123 568.456 301.191 567.897 303.545C567.321 305.963 566.053 309.593 572.313 311.257C577.882 312.741 596.335 317.668 597.836 338.74C599.592 363.397 575.933 373.825 571.958 367.417C566.081 357.939 566.051 345.945 568.249 341.564C569.753 338.564 575.117 338.05 574.607 333.961C573.871 328.06 563.654 328.936 556.944 324.931C550.229 320.927 548.022 312.996 548.994 305.829C550.124 297.495 557.907 292.206 564.982 295.073Z",
    fill: "url(#paint14_linear_1348_3000)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M609.99 340.529C611.388 347.131 608.916 354.117 604.4 355.213C599.612 356.374 595.317 352.063 593.719 344.902C592.25 338.318 593.833 331.163 599.065 329.671C604.098 328.236 608.593 333.925 609.99 340.529Z",
    fill: "url(#paint15_linear_1348_3000)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M626.705 325.778C629.503 333.137 627.332 340.513 621.696 343.285C614.523 346.812 608.411 342.357 605.613 334.998C602.813 327.64 605.232 318.06 610.885 315.328C616.539 312.599 623.906 318.421 626.705 325.778Z",
    fill: "url(#paint16_linear_1348_3000)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M635.493 309.934C638.907 314.718 637.949 321.864 634.039 325.408C630.125 328.954 624.186 327.951 620.772 323.167C617.358 318.384 617.177 312.213 621.089 308.667C625.001 305.123 632.078 305.152 635.493 309.934Z",
    fill: "url(#paint17_linear_1348_3000)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M630.186 289.312C631.277 285.217 634.78 282.78 638.01 283.872C641.241 284.964 642.977 289.169 641.888 293.265C640.797 297.36 637.296 299.796 634.063 298.705C630.833 297.614 629.096 293.407 630.186 289.312Z",
    fill: "url(#paint18_linear_1348_3000)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M585.609 325.865C585.496 329.659 584.733 333.362 583.444 336.785C582.159 340.213 580.368 343.367 578.268 346.194C576.688 348.316 574.95 350.251 573.079 351.972C572.77 352.255 572.459 352.531 572.148 352.794C571.845 353.048 571.503 353.329 571.26 353.502L575.02 360.154C575.475 359.745 575.811 359.407 576.177 359.031C576.535 358.665 576.881 358.294 577.221 357.918C579.237 355.685 581.076 353.22 582.716 350.555C584.888 347.02 586.696 343.112 587.899 338.906C589.108 334.709 589.668 330.213 589.455 325.804C589.348 323.565 589.057 321.347 588.587 319.181C587.326 318.196 586.012 317.317 584.654 316.553C585.358 319.623 585.705 322.766 585.609 325.865Z",
    fill: "url(#paint19_linear_1348_3000)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M573.142 367.753C578.136 367.753 582.186 362.862 582.186 356.827C582.186 350.793 578.136 345.901 573.142 345.901C568.147 345.901 564.098 350.793 564.098 356.827C564.098 362.862 568.147 367.753 573.142 367.753Z",
    fill: "#BE4118"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M573.142 361.672C575.356 361.672 577.152 359.503 577.152 356.828C577.152 354.152 575.356 351.983 573.142 351.983C570.927 351.983 569.132 354.152 569.132 356.828C569.132 359.503 570.927 361.672 573.142 361.672Z",
    fill: "#EA971D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M614.275 454.345C616.79 451.64 619.565 437.626 621.33 422.019C622.468 411.954 623.237 405.135 624.8 401.406C626.33 397.756 630.41 394.559 632.055 393.03C634.267 390.972 637.605 386.246 638.733 387.136C639.861 388.025 638.56 392.584 637.258 394.698C635.957 396.81 634.136 399.924 634.136 399.924C634.136 399.924 640.294 398.924 643.849 398.924C647.406 398.924 656.872 397.497 657.379 400.592C657.757 402.891 653.563 403.706 652.002 404.484C650.441 405.262 649.054 405.56 648.793 409.34C648.534 413.122 647.549 417.561 645.381 417.897C643.212 418.231 632.747 417.386 632.747 417.386C632.747 417.386 632.777 444.856 630.579 461.315C628.382 477.775 625.607 482.816 625.607 482.816L614.275 454.345Z",
    fill: "url(#paint20_linear_1348_3000)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M609.592 454.753C610.143 453.81 614.014 451.863 614.882 452.639C615.749 453.417 625.838 466.728 627.892 482C630.107 498.5 627.978 506.319 626.243 506.8C624.146 507.385 606.664 505.911 599.975 493.79C593.287 481.666 609.592 454.753 609.592 454.753Z",
    fill: "url(#paint21_linear_1348_3000)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M585.828 418.163C589.644 421.055 604.161 437.75 609.417 451.75C615.054 466.765 614.842 488.179 607.683 493.79C599.877 499.905 592.418 485.116 588.602 475.107C584.786 465.097 579.351 454.049 577.27 449.378C575.188 444.708 581.664 422.39 581.664 422.39L585.828 418.163Z",
    fill: "url(#paint22_linear_1348_3000)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M544.889 395.788C551.257 390.897 584.946 388.425 586.288 394.061C587.349 398.52 580.508 400.247 579.093 408.303C577.677 416.359 544.889 395.788 544.889 395.788Z",
    fill: "url(#paint23_linear_1348_3000)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M529.202 400.535C533.446 396.501 542.47 392.839 549.723 395.644C556.977 398.449 564.82 404.491 569.196 405.139C573.574 405.787 579.644 406.134 579.644 406.134C579.644 406.134 590.768 412.907 591.477 415.927C592.185 418.947 589.697 435.608 581.924 453.688C573.574 473.108 574.48 481.64 575.2 494.472C575.883 506.649 584.93 543.237 583.692 548.849C582.454 554.458 565.647 562.226 528.671 562.875C491.695 563.522 464.272 558.558 464.272 554.243C464.272 549.928 476.151 505.284 478.302 502.71C480.019 500.657 481.079 502.455 481.787 501.269C482.495 500.082 491.517 475.913 498.771 460.808C506.025 445.706 524.131 405.355 529.202 400.535Z",
    fill: "url(#paint24_linear_1348_3000)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514.605 523.279C520.12 520.87 521.535 509.149 520.129 509.272C512.629 509.938 487.627 505.909 481.474 501.603C480.775 502.032 479.781 500.94 478.301 502.71C477.272 503.94 474.022 514.786 470.907 526.243C480.563 526.498 508.578 525.912 514.605 523.279Z",
    fill: "url(#paint25_linear_1348_3000)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M549.253 448.006C550.619 450.101 555.298 446.029 557.066 445.167C558.836 444.303 564.887 441.931 564.851 439.34C564.806 436.211 559.212 435.515 555.12 437.722C550.52 440.203 547.822 445.812 549.253 448.006Z",
    fill: "#BE4118"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M591.477 415.926C590.883 413.397 582.978 408.231 580.432 406.624C581.333 408.303 582.748 411.18 579.21 413.051C575.671 414.92 561.046 417.51 561.872 424.557C562.699 431.608 572.015 424.702 574.257 428.443C576.497 432.184 565.765 441.822 570.011 445.562C574.257 449.302 577.324 436.931 580.98 437.506C583.759 437.944 584.492 442.535 584.738 446.608C590.297 431.433 592.091 418.547 591.477 415.926Z",
    fill: "url(#paint26_linear_1348_3000)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M574.613 543.094C569.422 541.799 565.647 546.691 563.642 545.253C561.638 543.815 571.19 533.887 566.708 530.148C562.228 526.406 556.565 540.073 555.386 539.929C554.207 539.784 560.222 521.948 561.047 515.905C561.874 509.862 562.817 496.34 557.982 495.333C553.146 494.327 548.546 505.259 546.423 510.295C544.3 515.331 542.059 531.874 540.88 532.451C539.7 533.025 539.228 510.151 538.993 506.845C538.754 503.535 538.284 499.731 534.981 499.65C532.092 499.579 530.736 503.823 530.382 507.849C530.029 511.878 532.976 542.375 529.91 542.952C526.844 543.527 523.658 530.291 521.064 532.164C518.469 534.032 520.12 541.369 521.535 546.835C522.623 551.033 525.859 558.238 527.573 562.889L528.671 562.875C559.64 562.331 576.454 556.794 581.828 551.712C580.366 548.404 577.83 543.897 574.613 543.094Z",
    fill: "url(#paint27_linear_1348_3000)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.3 523.602C570.069 524.789 572.635 520.903 574.316 517.669C575.997 514.431 577.765 508.93 575.732 507.527C573.696 506.126 570.512 508.176 568.921 512.704C567.326 517.237 566.532 522.413 568.3 523.602Z",
    fill: "#EA971D"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.861 370.051C457.105 366.328 428.148 327.914 428.936 323.072C429.747 318.091 430.063 313.807 430.472 311.028C431.216 305.963 434.527 298.654 433.973 297.668C433.158 296.223 431.112 297.615 429.131 299.937C427.573 301.768 422.704 309.604 422.704 309.604C422.704 309.604 419.545 308.837 414.936 304.457C410.326 300.077 406.059 293.178 403.765 293.917C401.784 294.556 403.668 298.324 404.606 300.077C405.546 301.828 406.275 304.643 406.486 305.538C407.032 307.867 407.125 314.805 406.144 317.377C405.587 318.839 404.436 319.02 404.352 320.992C404.262 323.076 409.815 329.972 413.313 331.285C416.038 332.308 416.557 331.396 417.156 332.27C418.19 333.786 438.14 379.456 446.349 387.133C454.558 394.812 460.861 370.051 460.861 370.051Z",
    fill: "url(#paint28_linear_1348_3000)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.394 301.828C406.424 303.613 407.561 305.307 408.706 306.981C409.279 307.814 409.864 308.635 410.461 309.442C411.054 310.228 411.677 311.068 412.297 311.663L412.324 311.687C412.52 311.874 412.561 312.233 412.415 312.485C412.38 312.547 412.335 312.599 412.282 312.638C412.23 312.676 412.171 312.701 412.111 312.71C412.05 312.719 411.988 312.712 411.93 312.689C411.872 312.666 411.818 312.629 411.772 312.579C411.031 311.778 410.495 310.934 409.911 310.077C409.344 309.22 408.791 308.35 408.249 307.469C407.172 305.703 406.111 303.926 405.147 302.045C405.125 302.003 405.117 301.951 405.125 301.9C405.133 301.85 405.157 301.806 405.191 301.777C405.223 301.752 405.263 301.743 405.301 301.752C405.338 301.762 405.372 301.789 405.394 301.828Z",
    fill: "#E08C7C"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M539.619 396.405C542.18 405.093 534.384 421.738 516.685 425.68C497.127 430.038 463.935 421.299 454.488 411.809C445.039 402.318 455.966 393.85 460.178 387.716C464.389 381.585 469.532 370.319 476.236 373.836C482.94 377.352 488.176 386.549 491.362 387.425C494.549 388.301 528.015 388.679 532.79 389.615C534.312 389.894 535.747 390.67 536.947 391.864C538.147 393.057 539.07 394.624 539.619 396.405Z",
    fill: "url(#paint29_linear_1348_3000)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M477.731 374.727C473.75 377.279 464.361 395.675 461.886 406.517C459.409 417.358 459.612 422.708 457.844 422.177C454.202 421.081 434.497 405.57 434.826 396.991C435.082 390.311 444.642 385.382 451.301 378.374C455.595 373.853 460.007 367.203 464.019 367.313C469.826 367.472 477.732 374.728 477.732 374.728L477.731 374.727Z",
    fill: "url(#paint30_linear_1348_3000)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M482.628 403.342C485.231 406.76 488.894 396.998 491.427 397.182C495.265 397.458 495.062 407.651 499.102 412.212C500.386 413.66 503.143 415.169 505.556 413.643C507.416 412.465 508.777 409.84 508.265 406.626C507.784 403.606 505.704 400.93 506.7 399.069C507.931 396.768 510.286 401.04 515.066 399.289C518.649 397.975 520.266 392.168 518.44 388.742C507.413 388.335 493.917 387.987 491.503 387.459C487.606 390.59 479.571 399.328 482.628 403.342Z",
    fill: "url(#paint31_linear_1348_3000)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M519.02 404.509C520.643 402.723 524.029 404.071 525.734 407.721C527.441 411.372 527.897 416.043 526.189 417.503C524.557 418.899 521.408 417.255 519.532 413.56C518.145 410.831 516.63 407.136 519.02 404.508V404.509Z",
    fill: "#EA971D"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.696 0.434082L659.076 32.7912L634.341 75.8047L605.865 41.55L628.696 0.434082Z",
    fill: "#5C60D5"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M669.034 75.8064H634.341L659.075 32.7915H693.612L669.034 75.8064Z",
    fill: "#BE4118"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M659.076 32.791H693.611L664.445 2.39064L628.697 0.432617L659.076 32.791Z",
    fill: "#EA971D"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M669.034 76.2392C668.942 76.2394 668.854 76.1962 668.788 76.1185L640.187 41.9831H605.866C605.818 41.9864 605.77 41.9776 605.725 41.9573C605.681 41.937 605.64 41.9055 605.605 41.8649C605.57 41.8243 605.543 41.7754 605.524 41.7211C605.505 41.6668 605.495 41.6084 605.495 41.5493C605.495 41.4902 605.505 41.4317 605.524 41.3774C605.543 41.3231 605.57 41.2742 605.605 41.2336C605.64 41.193 605.681 41.1616 605.725 41.1412C605.77 41.1209 605.818 41.1121 605.866 41.1154H640.33C640.422 41.1154 640.51 41.1597 640.575 41.2375L669.279 75.4922C669.33 75.552 669.366 75.6296 669.381 75.7148C669.395 75.7999 669.389 75.8887 669.363 75.9693C669.336 76.05 669.29 76.1188 669.232 76.1667C669.173 76.2147 669.104 76.2408 669.034 76.2392Z",
    fill: "#F2D265"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640.328 41.9849C640.263 41.9849 640.199 41.9623 640.144 41.9197C640.088 41.877 640.043 41.816 640.014 41.7435C639.985 41.671 639.973 41.5899 639.979 41.5094C639.986 41.4288 640.01 41.352 640.049 41.2875L664.163 2.127C664.22 2.03556 664.304 1.97561 664.397 1.96006C664.489 1.94451 664.583 1.9746 664.658 2.04385C664.813 2.18869 664.844 2.4596 664.725 2.65138L640.611 41.8119C640.578 41.8661 640.536 41.91 640.487 41.9403C640.438 41.9705 640.384 41.9863 640.33 41.9863L640.328 41.9849Z",
    fill: "#F2D265"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M667.066 13.5025L652.23 39.1942C652.929 40.1624 653.341 41.3965 653.398 42.6933C653.455 43.9902 653.154 45.2725 652.544 46.329C651.822 47.5736 650.732 48.4144 649.512 48.6685C648.292 48.9227 647.04 48.5696 646.029 47.6862C645.529 47.2523 645.104 46.7 644.778 46.0613C644.452 45.4226 644.231 44.71 644.128 43.9649C644.025 43.2198 644.043 42.4568 644.18 41.7201C644.317 40.9835 644.57 40.2877 644.925 39.673C646.204 37.4575 648.522 36.6998 650.484 37.6748L665.322 11.979L633.01 25.4009C633.01 25.4009 635.53 34.8772 635.362 41.2529C635.185 47.9289 630.032 56.6019 630.032 56.6019L635.233 61.1443L636.362 62.1327L638.105 63.6575L640.148 65.4412L644.436 69.1883C644.436 69.1883 649.395 60.349 654.462 57.943C659.3 55.647 667.402 55.4553 667.402 55.4553L667.067 13.5025H667.066Z",
    fill: "#2421A2"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M630.032 56.6028C630.032 56.6028 631.006 60.6489 636.017 65.0276C641.029 69.405 644.436 69.1891 644.436 69.1891C644.436 69.1891 647.072 64.4912 650.464 61.0137C650.464 61.0137 645.992 60.3002 641.176 56.0918C636.359 51.8847 634.323 46.9092 634.323 46.9092C632.769 51.992 630.032 56.6028 630.032 56.6028Z",
    fill: "url(#paint32_linear_1348_3000)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M634.341 76.2395C634.25 76.2396 634.161 76.1953 634.096 76.1161L605.619 41.8613C605.559 41.7904 605.522 41.6957 605.514 41.594C605.506 41.4924 605.527 41.3904 605.573 41.3061L628.404 0.187539C628.432 0.13702 628.469 0.0945199 628.511 0.0628471C628.554 0.0311743 628.601 0.0110505 628.65 0.00380612C628.7 -0.00435402 628.749 0.000642065 628.797 0.0184569C628.844 0.0362718 628.888 0.0664905 628.925 0.107072L659.305 32.4641C659.442 32.6103 659.467 32.8611 659.362 33.0435L634.628 76.0571C634.598 76.1085 634.56 76.1514 634.516 76.1827C634.472 76.2139 634.422 76.2329 634.372 76.2381L634.34 76.2395H634.341ZM606.322 41.4952L634.293 75.1384L658.602 32.8611L628.765 1.08072L606.322 41.4952Z",
    fill: "#F2D265"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M669.034 76.2395H634.341C634.277 76.2397 634.214 76.218 634.159 76.1768C634.104 76.1356 634.059 76.0765 634.029 76.006C634 75.9354 633.986 75.8561 633.99 75.7766C633.995 75.6972 634.016 75.6207 634.053 75.5556L658.787 32.5407C658.82 32.4839 658.863 32.4376 658.913 32.4056C658.963 32.3736 659.019 32.357 659.075 32.3569H693.612C693.676 32.3568 693.739 32.3785 693.794 32.4196C693.849 32.4608 693.894 32.5199 693.924 32.5905C693.953 32.6611 693.967 32.7404 693.963 32.8198C693.958 32.8993 693.937 32.9757 693.9 33.0409L669.323 76.0545C669.29 76.1117 669.247 76.1584 669.196 76.1906C669.146 76.2228 669.09 76.2396 669.034 76.2395ZM635.023 75.3718H668.851L692.932 33.226H659.258L635.023 75.3718Z",
    fill: "#F2D265"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M693.611 33.226H659.076C658.991 33.2258 658.909 33.1883 658.844 33.1201L628.465 0.763022C628.409 0.704432 628.37 0.625543 628.353 0.537628C628.336 0.449713 628.341 0.357272 628.369 0.273515C628.425 0.101852 628.539 -0.0134838 628.713 0.00126848L664.461 1.9593C664.539 1.96332 664.612 1.99953 664.672 2.06256L693.84 32.4616C693.896 32.5185 693.936 32.5957 693.955 32.6823C693.974 32.7689 693.97 32.8606 693.945 32.9447C693.92 33.0287 693.874 33.1009 693.814 33.1511C693.754 33.2013 693.683 33.2284 693.611 33.226ZM659.206 32.357H692.649L664.308 2.81761L629.696 0.923956L659.206 32.357Z",
    fill: "#F2D265"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.212 40.6408L153.847 23.3149L168.068 83.7778L118.435 101.1L104.212 40.6408Z",
    fill: "url(#paint33_linear_1348_3000)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.036 40.749L153.999 23.4164L123.743 9.90332L77.1541 26.399L105.036 40.749Z",
    fill: "#5C60D5"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.151 40.6555L76.0715 25.9971L89.6286 85.2703L118.282 102.441L104.151 40.6555Z",
    fill: "url(#paint34_linear_1348_3000)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4056 85.0064C89.3228 85.0055 89.2431 84.968 89.1807 84.9006C89.1183 84.8333 89.0775 84.7404 89.0656 84.639C89.0537 84.5375 89.0715 84.4341 89.1158 84.3475C89.1601 84.2609 89.2279 84.1968 89.3071 84.1668L136.984 66.668L122.535 9.11806C122.514 9.01181 122.526 8.89949 122.569 8.80409C122.613 8.70869 122.684 8.63742 122.768 8.60487C122.853 8.57231 122.944 8.58093 123.023 8.62896C123.103 8.67699 123.164 8.7608 123.195 8.86325L137.748 66.8302C137.775 66.94 137.766 67.0586 137.723 67.1602C137.702 67.2103 137.673 67.2546 137.638 67.2904C137.602 67.3261 137.561 67.3525 137.518 67.368L89.5019 84.9903C89.47 85.0004 89.4384 85.0058 89.4056 85.0064ZM167.729 83.6653C167.681 83.665 167.633 83.6517 167.589 83.6264L137.961 67.0234C137.921 67.0009 137.885 66.9689 137.855 66.9291C137.825 66.8892 137.801 66.8424 137.786 66.7913C137.77 66.7403 137.763 66.6859 137.765 66.6313C137.766 66.5768 137.776 66.5232 137.795 66.4735C137.833 66.373 137.901 66.2951 137.985 66.2565C138.069 66.2179 138.162 66.2216 138.244 66.267L167.871 82.87C167.941 82.909 167.999 82.9769 168.034 83.0622C168.068 83.1476 168.078 83.2452 168.062 83.3386C168.045 83.4319 168.003 83.5154 167.943 83.5749C167.883 83.6344 167.807 83.6663 167.73 83.6653H167.729Z",
    fill: "#EA971D"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M157.76 73.3925L147.241 76.7976L140.2 64.7544L121.056 70.9544L119.963 85.6302L109.706 88.9521L115.768 23.9349L125.993 20.625L157.761 73.3925H157.76ZM134.864 55.6281L123.705 36.0746L121.908 60.0538L134.864 55.6281Z",
    fill: "#5B252C"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.995 20.6233L120.634 18.2817L110.408 21.5903L115.77 23.9332L125.995 20.6233Z",
    fill: "#93778B"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.707 88.9506L104.346 86.609L110.408 21.5918L115.77 23.9334L109.707 88.9506ZM141.881 74.4545L147.242 76.7974L140.202 64.7542L136.844 65.8405L141.881 74.4545ZM129.614 53.4808L123.239 42.2973L123.705 36.0745L134.865 55.6279L129.614 53.4808Z",
    fill: "#724A5F"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.222 55.873L129.615 53.4805L134.865 55.6263L121.91 60.0519L122.222 55.873Z",
    fill: "#93778B"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M118.626 102.441C118.55 102.44 118.478 102.409 118.418 102.353C118.358 102.296 118.315 102.217 118.295 102.127L104.225 40.2547C104.2 40.1453 104.21 40.0278 104.254 39.9279C104.298 39.8279 104.372 39.7535 104.46 39.7209L153.562 21.9914C153.605 21.9756 153.65 21.9706 153.695 21.9766C153.74 21.9825 153.783 21.9994 153.822 22.0262C153.902 22.083 153.961 22.1764 153.986 22.2864L168.055 84.1587C168.081 84.2684 168.071 84.3864 168.027 84.4869C167.983 84.5874 167.908 84.6623 167.82 84.6952L118.72 102.425C118.689 102.435 118.657 102.441 118.626 102.441ZM104.981 40.4303L118.862 101.473L167.301 83.983L153.422 22.9409L104.981 40.4303Z",
    fill: "#EA971D"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M104.439 40.7497C104.394 40.7497 104.349 40.7383 104.308 40.7162L76.2833 26.1423C76.217 26.1078 76.1611 26.0486 76.1232 25.9729C76.0854 25.8972 76.0676 25.8087 76.0723 25.7198C76.0809 25.5388 76.1805 25.3845 76.3212 25.3349L123.15 8.57904C123.219 8.55377 123.293 8.55754 123.361 8.58976L153.77 22.3147C153.839 22.346 153.898 22.4032 153.938 22.4783C153.979 22.5533 154 22.6424 153.997 22.7328C153.995 22.8232 153.97 22.9104 153.925 22.9819C153.88 23.0535 153.819 23.1058 153.749 23.1315L104.535 40.7336C104.504 40.7443 104.471 40.7497 104.439 40.7497ZM77.4544 25.8231L104.46 39.8686L152.537 22.6728L123.232 9.44539L77.4544 25.8217V25.8231Z",
    fill: "#EA971D"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M117.944 102.441C117.893 102.442 117.842 102.428 117.797 102.401L89.6035 85.422C89.5599 85.3956 89.5213 85.3581 89.4903 85.3118C89.4594 85.2656 89.4367 85.2117 89.4238 85.1538L76.0854 26.5417C76.0676 26.4648 76.0676 26.3832 76.0852 26.3062C76.1027 26.2292 76.1373 26.1599 76.185 26.1058C76.2321 26.052 76.2908 26.0162 76.3539 26.0026C76.4171 25.9891 76.482 25.9984 76.541 26.0294L104.169 40.5255C104.217 40.5507 104.259 40.5889 104.293 40.6372C104.327 40.6855 104.352 40.7427 104.365 40.8045L118.268 101.898C118.286 101.977 118.286 102.06 118.267 102.139C118.248 102.217 118.211 102.288 118.161 102.342C118.101 102.406 118.024 102.441 117.944 102.441ZM90.0342 84.7327L117.41 101.22L103.76 41.235L76.9317 27.1613L90.0342 84.7327Z",
    fill: "#EA971D"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M635.788 282.188L668.338 310.738V260.08L635.788 239.885V282.188Z",
    fill: "url(#paint35_linear_1348_3000)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M698.914 284.56L667.352 310.738V259.953L698.914 241.105V284.56Z",
    fill: "url(#paint36_linear_1348_3000)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M667.568 260.652L698.914 241.61L667.19 226.447L634.802 240.2L667.568 260.652Z",
    fill: "url(#paint37_linear_1348_3000)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M698.632 285.085C698.589 285.085 698.546 285.071 698.506 285.047L667.177 265.064L635.195 282.57C635.161 282.588 635.124 282.598 635.087 282.599C635.05 282.599 635.014 282.591 634.979 282.574C634.945 282.557 634.914 282.531 634.887 282.499C634.861 282.467 634.84 282.429 634.826 282.386C634.796 282.3 634.795 282.203 634.822 282.116C634.849 282.029 634.903 281.958 634.972 281.92L667.074 264.347C667.112 264.326 667.153 264.316 667.194 264.318C667.235 264.32 667.276 264.333 667.312 264.356L698.76 284.413C698.899 284.501 698.955 284.714 698.885 284.89C698.861 284.948 698.825 284.997 698.781 285.032C698.736 285.066 698.685 285.084 698.632 285.085Z",
    fill: "#F2D265"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M667.845 265.539C667.625 265.539 667.449 265.384 667.449 265.193V226.793C667.449 226.603 667.627 226.447 667.845 226.447C668.065 226.447 668.241 226.603 668.241 226.793V265.193C668.241 265.384 668.065 265.539 667.845 265.539Z",
    fill: "#F2D265"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M649.597 255.953C649.597 268.782 657.715 274.809 657.715 277.209L658.28 286.307H675.437L676.002 277.209C676.001 274.808 684.12 269.309 684.12 255.953C684.12 245.864 676.339 238.664 666.87 238.664C657.4 238.664 649.597 246.111 649.597 255.953Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M676.298 285.085H658.405L658.386 284.765C657.813 275.796 657.813 275.792 657.813 275.772C657.813 275.188 657.052 274.132 656.088 272.795C653.66 269.424 649.597 263.782 649.597 254.826C649.597 245.078 657.401 237.441 667.363 237.441C677.479 237.441 685.106 244.915 685.106 254.826C685.106 264.202 681.013 269.683 678.569 272.957C677.63 274.211 676.891 275.2 676.891 275.773C676.891 275.792 676.891 275.796 676.317 284.765L676.298 285.085ZM658.933 284.392H675.773C675.874 282.806 676.318 275.854 676.324 275.749C676.323 274.935 677.049 273.963 678.148 272.49C680.537 269.292 684.539 263.936 684.539 254.828C684.539 245.311 677.154 238.135 667.364 238.135C657.721 238.135 650.166 245.467 650.166 254.828C650.166 263.522 654.143 269.042 656.519 272.339C657.641 273.898 658.383 274.928 658.383 275.773L658.933 284.392Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M660.072 263.499C658.745 263.499 657.664 262.203 657.664 260.613C657.664 259.021 658.745 257.725 660.072 257.725C661.399 257.725 662.479 259.021 662.479 260.613C662.479 262.203 661.4 263.499 660.072 263.499ZM660.072 258.759C659.22 258.759 658.526 259.591 658.526 260.613C658.526 261.633 659.219 262.463 660.072 262.463C660.923 262.463 661.616 261.633 661.616 260.613C661.616 259.591 660.924 258.759 660.072 258.759ZM676.334 263.499C675.007 263.499 673.927 262.203 673.927 260.613C673.927 259.021 675.007 257.725 676.334 257.725C677.661 257.725 678.741 259.021 678.741 260.613C678.741 262.203 677.661 263.499 676.334 263.499ZM676.334 258.759C675.482 258.759 674.789 259.591 674.789 260.613C674.789 261.633 675.482 262.463 676.334 262.463C677.185 262.463 677.879 261.633 677.879 260.613C677.879 259.591 677.185 258.759 676.334 258.759Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M671.765 285.038H664.388L660.102 263.034L660.941 262.801L665.071 284.004H671.089L675.444 262.788L676.282 263.034L671.765 285.038ZM675.123 258.74C674.002 256.547 671.822 253.934 667.796 253.934C663.843 253.934 661.974 256.472 661.101 258.601L660.327 258.145C661.129 256.185 663.167 252.901 667.796 252.901C672.454 252.901 674.847 256.221 675.859 258.2L675.123 258.74Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M660.043 289.106L658.474 291.768C658.474 295.499 664.478 298.523 667.505 298.523H667.756C670.783 298.523 676.229 295.499 676.229 291.768L674.642 289.106C674.642 285.374 660.043 285.374 660.043 289.106Z",
    fill: "#93778B"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M677.215 281.419C677.215 281.419 675.118 283.208 668.249 283.208C661.377 283.208 658.474 281.419 658.474 281.419L659.06 292.99C659.06 292.99 662.952 294.857 668.249 294.857C673.544 294.857 676.649 292.99 676.649 292.99L677.215 281.419Z",
    fill: "url(#paint38_linear_1348_3000)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M668.053 311.961C667.994 311.961 667.936 311.939 667.887 311.896L634.923 283.136C634.886 283.104 634.856 283.061 634.834 283.012C634.813 282.962 634.802 282.907 634.802 282.85V240.236C634.802 240.176 634.815 240.117 634.839 240.065C634.863 240.013 634.897 239.969 634.938 239.937C634.98 239.906 635.027 239.888 635.075 239.886C635.124 239.883 635.172 239.896 635.215 239.923L668.181 260.266C668.277 260.325 668.337 260.446 668.337 260.578V311.609C668.338 311.656 668.33 311.701 668.316 311.744C668.302 311.787 668.281 311.826 668.254 311.859C668.228 311.891 668.196 311.917 668.162 311.935C668.127 311.952 668.09 311.961 668.053 311.961ZM635.372 282.668L667.766 310.931V260.796L635.372 240.805V282.668Z",
    fill: "#F2D265"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M668.619 311.96C668.582 311.961 668.545 311.952 668.511 311.935C668.477 311.918 668.446 311.892 668.42 311.86C668.393 311.828 668.373 311.79 668.359 311.748C668.344 311.705 668.337 311.66 668.337 311.614V261.336C668.337 261.203 668.399 261.082 668.495 261.025L699.497 242.363C699.54 242.338 699.587 242.326 699.634 242.329C699.682 242.332 699.728 242.35 699.768 242.381C699.808 242.412 699.842 242.455 699.865 242.507C699.888 242.558 699.9 242.615 699.901 242.674V285.697C699.901 285.754 699.889 285.809 699.868 285.859C699.846 285.909 699.815 285.951 699.777 285.983L668.777 311.9C668.73 311.939 668.675 311.96 668.619 311.96ZM668.9 261.55V310.961L699.339 285.513V243.228L668.9 261.55ZM667.561 260.652C667.517 260.652 667.474 260.64 667.435 260.616L634.958 240.575C634.908 240.545 634.868 240.498 634.84 240.439C634.812 240.38 634.8 240.312 634.803 240.244C634.807 240.176 634.827 240.111 634.861 240.057C634.894 240.003 634.94 239.962 634.992 239.94L667.096 226.466C667.158 226.44 667.226 226.441 667.288 226.47L698.734 241.326C698.785 241.351 698.828 241.392 698.86 241.447C698.892 241.501 698.911 241.565 698.914 241.632C698.916 241.7 698.902 241.767 698.874 241.825C698.846 241.883 698.805 241.93 698.756 241.959L667.684 260.614C667.646 260.639 667.604 260.652 667.561 260.652ZM635.808 240.329L667.564 259.922L697.93 241.687L667.181 227.16L635.808 240.329Z",
    fill: "#F2D265"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M643.441 835.864L611.689 828.703L630.927 816.981L657.746 819.312L643.441 835.864Z",
    fill: "url(#paint39_linear_1348_3000)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.658 855.667H39.6083L0 904.08H244.708L208.658 855.667Z",
    fill: "url(#paint40_linear_1348_3000)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.707 904.08L208.658 855.667V904.08H244.707Z",
    fill: "#B5A8AE"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6083 855.667L0 904.08H39.6668V855.667H39.6083Z",
    fill: "url(#paint41_linear_1348_3000)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.705 471.441L261.76 464.086H257.218L172.317 902.769H189.728L265.705 471.441Z",
    fill: "url(#paint42_linear_1348_3000)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.137 471.429L184.803 464.086H179.91L76.489 902.769H96.7531L188.137 471.429Z",
    fill: "url(#paint43_linear_1348_3000)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.913 519.938C176.954 519.938 168.736 522.033 170.386 525.636C171.919 528.98 174.735 531.797 175.297 531.797L242.035 532.844L244.533 519.938H177.913Z",
    fill: "url(#paint44_linear_1348_3000)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.645 586.704C162.686 586.704 153.945 589.339 155.774 592.806C157.521 596.119 160.642 598.564 161.202 598.564L228.973 600.339L231.612 586.705H163.645V586.704Z",
    fill: "url(#paint45_linear_1348_3000)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.741 662.552C146.783 662.552 136.91 666.924 138.937 670.216C140.799 673.242 144.564 674.411 145.124 674.411L214.285 676.222L216.931 662.553H147.741V662.552Z",
    fill: "url(#paint46_linear_1348_3000)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.642 747.993C128.684 747.993 118.632 753.73 120.637 757.044C122.202 759.631 126.465 759.854 127.026 759.854L197.744 761.704L200.396 747.993H129.642Z",
    fill: "url(#paint47_linear_1348_3000)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.802 464.086H175.018L71.5979 902.769H89.0686L184.802 464.086Z",
    fill: "url(#paint48_linear_1348_3000)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.894 514.599C172.935 514.599 169.844 515.915 169.218 519.986C168.644 523.716 170.717 526.459 171.277 526.459L243.199 526.834L245.567 514.599H173.894Z",
    fill: "url(#paint49_linear_1348_3000)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.254 581.327C158.295 581.327 155.205 582.645 154.576 586.714C154.003 590.447 156.078 594.056 156.637 594.056L229.9 594.823L232.511 581.327H159.254Z",
    fill: "url(#paint50_linear_1348_3000)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.273 657.883C141.315 657.883 138.224 659.198 137.596 663.269C137.023 666.999 139.096 671.044 139.656 671.044L215.059 672.227L217.834 657.883H142.273Z",
    fill: "url(#paint51_linear_1348_3000)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.814 744.07C122.857 744.07 119.765 745.387 119.139 749.458C118.563 753.189 120.638 757.667 121.197 757.667L198.211 759.277L201.155 744.07H123.814Z",
    fill: "url(#paint52_linear_1348_3000)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.76 464.086H251.977L167.075 902.769H181.517L261.76 464.086Z",
    fill: "url(#paint53_linear_1348_3000)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.115 681.349C120.116 677.979 125.333 668.222 129.594 663.271C133.001 659.314 140.123 652.268 142.898 651.061C146.116 649.662 149.855 651.006 149.855 651.006C149.855 651.006 153.073 650.201 154.986 650.899C156.751 651.543 157.247 652.621 157.247 652.621C157.247 652.621 160.463 651.98 162.291 652.406C164.356 652.886 165.072 655.418 164.899 657.891C164.726 660.367 155.594 677.584 148.464 681.779C141.334 685.974 132.551 688.666 129.159 693.401C125.767 698.136 116.115 681.349 116.115 681.349Z",
    fill: "url(#paint54_linear_1348_3000)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4731 835.218C30.0242 824.886 57.503 762.049 74.8957 733.213C92.2885 704.376 111.419 681.133 112.636 680.488C113.854 679.842 120.636 679.842 124.637 683.286C128.637 686.728 131.072 691.464 130.898 693.831C130.725 696.199 116.997 725.02 110.724 745.906C104.449 766.797 84.1138 825.532 84.1138 825.532L27.4731 835.218Z",
    fill: "url(#paint55_linear_1348_3000)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.816 657.407C164.786 656.996 164.548 656.72 164.238 656.607C163.932 656.494 163.589 656.5 163.258 656.559C162.59 656.682 161.948 657.015 161.361 657.437C160.769 657.857 160.268 658.425 159.753 659.014L158.235 660.815C157.222 662.022 156.2 663.235 155.099 664.363C154.546 664.923 153.974 665.465 153.346 665.948C152.713 666.41 152.047 666.889 151.144 666.968C151.07 666.981 150.993 666.975 150.921 666.95C150.848 666.925 150.78 666.882 150.721 666.823C150.662 666.765 150.614 666.692 150.579 666.609C150.543 666.526 150.522 666.435 150.517 666.341C150.511 666.248 150.521 666.154 150.546 666.066C150.571 665.977 150.61 665.896 150.662 665.827C150.713 665.759 150.775 665.704 150.844 665.666C150.913 665.628 150.988 665.608 151.063 665.607C151.079 665.606 151.092 665.603 151.108 665.603L151.119 665.606C151.636 665.61 152.271 665.274 152.847 664.888C153.441 664.474 154.013 664.011 154.558 663.503C155.67 662.486 156.732 661.356 157.791 660.217L159.395 658.51C159.933 657.955 160.502 657.375 161.154 656.969C161.798 656.559 162.491 656.254 163.221 656.166C163.586 656.125 163.963 656.137 164.325 656.3C164.506 656.38 164.68 656.513 164.812 656.702C164.942 656.882 165.015 657.162 165.024 657.373L165.025 657.39C165.027 657.424 165.017 657.458 164.999 657.484C164.98 657.509 164.954 657.525 164.927 657.527C164.913 657.528 164.899 657.526 164.887 657.521C164.874 657.516 164.862 657.507 164.852 657.496C164.841 657.485 164.833 657.472 164.827 657.457C164.821 657.442 164.817 657.426 164.816 657.409V657.407ZM158.257 652.609C157.054 653.089 155.914 653.782 154.872 654.668C154.352 655.103 153.854 655.58 153.367 656.078C152.875 656.575 152.415 657.102 151.848 657.613C151.787 657.667 151.717 657.705 151.644 657.725C151.57 657.745 151.494 657.747 151.42 657.729C151.346 657.712 151.276 657.676 151.214 657.624C151.151 657.571 151.098 657.504 151.057 657.426C151.017 657.347 150.989 657.259 150.977 657.167C150.964 657.075 150.967 656.981 150.985 656.89C151.003 656.8 151.035 656.714 151.081 656.64C151.126 656.565 151.183 656.503 151.248 656.457L151.256 656.453C151.763 656.1 152.298 655.621 152.84 655.184C153.384 654.745 153.944 654.322 154.526 653.946C155.679 653.187 156.913 652.636 158.192 652.31H158.197C158.213 652.306 158.229 652.306 158.245 652.31C158.261 652.313 158.277 652.321 158.29 652.332C158.304 652.344 158.315 652.358 158.324 652.375C158.333 652.392 158.34 652.411 158.343 652.431C158.348 652.468 158.342 652.507 158.327 652.54C158.311 652.573 158.286 652.597 158.256 652.609H158.257ZM150.924 650.947C149.84 651.371 148.88 652.153 147.991 653.022C147.547 653.457 147.123 653.926 146.72 654.415C146.33 654.897 145.908 655.445 145.648 655.926L145.63 655.959C145.594 656.026 145.549 656.083 145.495 656.128C145.441 656.172 145.381 656.203 145.318 656.219C145.255 656.235 145.19 656.235 145.126 656.219C145.063 656.204 145.003 656.173 144.949 656.128C144.891 656.081 144.842 656.02 144.805 655.948C144.767 655.876 144.743 655.795 144.733 655.71C144.723 655.625 144.728 655.539 144.747 655.456C144.766 655.374 144.798 655.298 144.843 655.232C145.287 654.575 145.72 654.149 146.185 653.671C146.648 653.211 147.128 652.785 147.625 652.389C148.617 651.607 149.69 650.918 150.852 650.617C150.87 650.612 150.888 650.612 150.906 650.616C150.924 650.62 150.941 650.628 150.956 650.64C150.972 650.652 150.985 650.668 150.995 650.686C151.006 650.705 151.013 650.726 151.017 650.748C151.023 650.789 151.018 650.832 151.001 650.869C150.983 650.906 150.956 650.934 150.924 650.947Z",
    fill: "#C97165"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M121.79 749.289C117.069 749.289 113.229 743.413 113.229 736.189C113.229 728.964 117.069 723.087 121.79 723.087C126.508 723.087 130.349 728.964 130.349 736.189C130.349 743.413 126.508 749.289 121.79 749.289ZM121.7 725.924C118.545 725.924 116.066 730.969 116.066 736.19C116.066 741.412 118.588 746.285 121.744 746.285C124.899 746.285 127.51 741.412 127.51 736.19C127.51 730.969 124.854 725.924 121.7 725.924Z",
    fill: "#5C60D5"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.284 712.88C120.857 722.068 124.316 757.118 116.866 775.946C109.965 793.377 102.494 791.372 102.494 791.372L102.316 814.055L61.5098 812.016C61.5098 812.016 70.0276 793.186 71.624 780.257C73.2193 767.327 79.9621 731.48 84.5738 723.997C89.1867 716.509 118.284 712.88 118.284 712.88Z",
    fill: "url(#paint56_linear_1348_3000)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.741 691.177C129.248 695.603 128.999 706.912 123.312 713.26C116.805 720.521 107.048 718.63 105.982 728.61C105.2 735.954 111.346 743.309 113.139 748.043C114.914 752.73 115.267 758.327 113.258 759.839C111.097 761.464 109.138 757.923 108.585 755.53C107.994 752.973 107.268 748.487 103.44 748.951C99.0642 749.481 93.8009 760.295 98.4721 766.041C100.379 768.385 103.795 765.889 104.623 768.006C105.737 770.849 100.779 780.258 94.8063 780.407C89.805 780.532 89.6621 776.249 83.5102 776.021C78.8758 775.85 72.3343 781.92 71.6232 780.257C70.9132 778.591 70.7065 774.522 69.0213 770.426C67.189 765.962 51.1632 750.008 54.829 724.296C57.4568 705.881 68.1944 695.905 81.0285 692.918C93.8323 689.938 102.378 689.97 105.69 688.758C109 687.551 121.773 682.408 126.741 691.177Z",
    fill: "url(#paint57_linear_1348_3000)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.504 791.388L102.689 783.479C102.69 783.361 102.729 783.247 102.798 783.164C102.866 783.082 102.958 783.036 103.054 783.037C103.103 783.04 103.152 783.055 103.196 783.082C103.241 783.11 103.28 783.148 103.312 783.194C103.345 783.241 103.369 783.295 103.384 783.354C103.398 783.413 103.403 783.474 103.398 783.536L102.805 791.411C102.803 791.436 102.798 791.46 102.789 791.482C102.78 791.504 102.767 791.524 102.752 791.541C102.737 791.557 102.719 791.569 102.7 791.577C102.681 791.584 102.66 791.587 102.64 791.585C102.601 791.58 102.566 791.557 102.54 791.52C102.515 791.484 102.502 791.436 102.504 791.388Z",
    fill: "#C97165"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.973 732.346C129.546 731.504 128.725 731.791 128.065 732.333L111.949 745.501C112.43 746.41 112.845 747.262 113.14 748.043C113.198 748.197 113.251 748.352 113.306 748.508L129.507 734.884C130.164 734.34 130.397 733.188 129.973 732.346Z",
    fill: "url(#paint58_linear_1348_3000)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0087 819.782C55.6537 817.345 56.2457 807.599 61.5761 805.173C68.2399 802.141 101.97 803.16 108.959 820.501C92.3744 825.659 56.0087 819.783 56.0087 819.783V819.782Z",
    fill: "url(#paint59_linear_1348_3000)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5847 904.427H134.923C136.023 893.299 139.729 873.512 137.458 856.791C134.871 837.735 120.295 819.105 116.535 818.254C113.854 817.648 90.3201 817.257 82.0913 817.257C70.0808 817.257 51.8601 817.102 46.5892 819.248C37.5086 822.946 27.9302 836.374 27.0752 839.156C26.5708 840.799 25.772 854.815 30.9152 874.295C34.4013 887.51 39.4449 897.638 43.5847 904.427Z",
    fill: "url(#paint60_linear_1348_3000)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5257 888.334L43.3572 877.605L49.4311 888.334H37.5257ZM45.1159 833.348L47.2665 845.418L36.4434 843.179L45.1159 833.348ZM102.478 885.652L104.629 897.722L93.8059 895.482L102.478 885.652ZM71.0774 874.638L81.9005 872.24L79.8939 884.311L71.0774 874.638ZM81.9005 840.054L90.559 847.28L81.9005 854.806V840.054Z",
    fill: "#BE4118"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.5014 840.054V835.664C64.2839 835.663 65.0342 835.277 65.5875 834.592C66.1408 833.906 66.452 832.976 66.4529 832.007C66.452 831.037 66.1408 830.108 65.5875 829.422C65.0342 828.736 64.2839 828.351 63.5014 828.35V823.96C67.0828 823.96 69.9953 827.57 69.9953 832.007C69.9953 836.446 67.0828 840.054 63.5014 840.054ZM91.7097 823.96L95.2337 824.604C94.9978 826.638 96.1234 828.536 97.7425 828.832C99.3617 829.129 100.87 827.714 101.106 825.679L104.629 826.326C104.111 830.802 100.791 833.914 97.2284 833.261C93.6666 832.61 91.1913 828.437 91.7097 823.96ZM47.3696 825.502C49.3664 824.003 50.4834 821.338 50.5137 818.596C49.0331 818.846 47.8111 819.147 46.9464 819.517C46.9244 819.528 46.902 819.538 46.8793 819.547C46.6773 820.435 46.2129 821.196 45.5783 821.679C45.1756 821.983 44.7186 822.158 44.2478 822.19C43.7771 822.222 43.3073 822.11 42.8801 821.863C41.7809 822.653 40.7163 823.516 39.6906 824.446C41.7275 826.854 44.8554 827.396 47.3696 825.502ZM31.7821 873.581L30.9877 869.618C32.4759 869.172 33.3904 867.325 33.0257 865.504C32.6599 863.681 31.1522 862.561 29.6629 863.009L28.8674 859.044C32.1436 858.061 35.463 860.523 36.2661 864.529C37.0714 868.539 35.0593 872.601 31.7821 873.581ZM52.6783 858.829H56.2207C56.2216 859.799 56.5328 860.728 57.0861 861.414C57.6394 862.1 58.3897 862.485 59.1722 862.486C59.9549 862.486 60.7054 862.1 61.2589 861.414C61.8125 860.729 62.1239 859.799 62.1247 858.829H65.6661C65.6661 863.266 62.7535 866.876 59.1722 866.876C55.5919 866.876 52.6783 863.266 52.6783 858.829ZM56.6969 886.993L59.143 890.025C58.6033 890.695 58.3002 891.603 58.3002 892.549C58.3002 893.496 58.6033 894.404 59.143 895.074C59.6837 895.744 60.4168 896.12 61.1813 896.12C61.9457 896.121 62.679 895.745 63.22 895.075L65.6661 898.106C64.4757 899.578 62.8629 900.404 61.1815 900.404C59.5001 900.404 57.8873 899.578 56.6969 898.106C55.5095 896.631 54.8426 894.633 54.8426 892.549C54.8426 890.466 55.5095 888.468 56.6969 886.993ZM119.472 884.31L121.918 887.343C121.379 888.013 121.075 888.921 121.075 889.867C121.075 890.814 121.379 891.722 121.918 892.392C122.459 893.061 123.192 893.437 123.956 893.437C124.72 893.438 125.453 893.062 125.994 892.393L128.44 895.424C127.25 896.895 125.637 897.721 123.956 897.721C122.275 897.721 120.662 896.895 119.472 895.424C118.284 893.949 117.617 891.951 117.617 889.867C117.617 887.784 118.284 885.785 119.472 884.31ZM100.3 856.147V860.535C99.5173 860.536 98.767 860.922 98.2136 861.608C97.6603 862.294 97.3492 863.224 97.3486 864.194C97.3492 865.163 97.6603 866.093 98.2136 866.779C98.767 867.465 99.5173 867.851 100.3 867.852V872.24C96.7187 872.24 93.8062 868.63 93.8062 864.194C93.8062 859.755 96.7198 856.147 100.3 856.147ZM86.23 904.427H82.6876C82.6867 903.457 82.3753 902.527 81.8218 901.842C81.2682 901.156 80.5177 900.771 79.735 900.77C78.9521 900.77 78.2014 901.156 77.6476 901.841C77.0938 902.527 76.7823 903.457 76.7814 904.427H73.2422C73.2422 899.991 76.1558 896.38 79.7361 896.38C83.3175 896.38 86.23 899.991 86.23 904.427Z",
    fill: "#EA971D"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.534 803.442C169.002 797.865 168.824 791.412 166.609 782.77C164.392 774.129 162.856 770.709 163.124 766.333C165.459 766.381 169.269 766.363 169.269 766.363C169.163 767.753 170.091 757.561 173.436 752.471C176.744 747.44 182.242 741.461 185.313 742.298C186.309 742.57 185.785 746.27 185.785 746.27C185.785 746.27 190.656 744.316 192.672 744.922C194.001 745.325 194.001 747.44 194.001 747.44C194.001 747.44 195.863 747.221 196.484 748.533C197.105 749.846 195.071 752.561 194.268 754.769C193.158 757.813 192.354 759.691 192.139 764.831C191.731 774.664 190.988 782.333 189.48 786.272C187.974 790.208 187.885 796.99 187.885 800.599C187.885 804.209 169.533 803.442 169.533 803.442H169.534Z",
    fill: "url(#paint61_linear_1348_3000)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.932 746.046C185.683 746.781 184.589 747.885 183.563 749.037C182.546 750.206 181.602 751.48 180.802 752.859C180.734 752.958 180.638 753.022 180.534 753.039C180.429 753.055 180.323 753.022 180.237 752.947C180.151 752.871 180.091 752.758 180.069 752.631C180.046 752.503 180.063 752.37 180.116 752.257L180.135 752.23C181.05 750.865 182.073 749.616 183.189 748.503C184.3 747.407 185.473 746.365 186.811 745.703C186.849 745.684 186.891 745.685 186.928 745.705C186.965 745.724 186.995 745.761 187.011 745.807C187.023 745.852 187.023 745.901 187.008 745.945C186.993 745.989 186.966 746.025 186.932 746.046ZM194.259 747.611C193.182 748.127 192.297 749.1 191.512 750.142C190.733 751.194 190.045 752.368 189.467 753.591C189.404 753.726 189.3 753.824 189.178 753.865C189.056 753.906 188.927 753.885 188.817 753.808C188.763 753.77 188.715 753.719 188.677 753.657C188.639 753.596 188.61 753.526 188.594 753.451C188.578 753.376 188.574 753.298 188.582 753.222C188.59 753.145 188.61 753.071 188.642 753.004C188.649 752.99 188.66 752.973 188.666 752.958C189.369 751.733 190.175 750.603 191.069 749.588C191.963 748.595 192.975 747.67 194.157 747.246C194.197 747.232 194.239 747.237 194.275 747.261C194.312 747.285 194.339 747.325 194.352 747.374C194.362 747.42 194.358 747.47 194.341 747.513C194.324 747.556 194.295 747.591 194.259 747.61V747.611ZM169.551 765.661C169.316 766.906 169.354 768.203 169.455 769.483C169.51 770.122 169.585 770.763 169.678 771.398C169.769 772.041 169.879 772.658 169.986 773.324C170.009 773.471 169.984 773.623 169.917 773.747C169.85 773.87 169.745 773.956 169.627 773.985C169.509 774.013 169.386 773.983 169.286 773.899C169.186 773.816 169.117 773.687 169.094 773.54C169.091 773.525 169.09 773.509 169.087 773.492L169.086 773.478C169.032 772.853 168.963 772.179 168.92 771.52C168.873 770.858 168.842 770.193 168.834 769.526C168.824 768.199 168.884 766.835 169.224 765.551C169.23 765.525 169.241 765.5 169.255 765.479C169.27 765.458 169.287 765.44 169.307 765.427C169.326 765.414 169.348 765.407 169.37 765.404C169.392 765.402 169.415 765.405 169.436 765.413C169.476 765.43 169.51 765.464 169.532 765.51C169.553 765.556 169.56 765.61 169.551 765.661Z",
    fill: "#C97165"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.761 801.765C169.179 799.26 174.381 795.931 179.464 795.787C184.546 795.64 190.22 798.703 190.573 800.89C190.927 803.079 201.449 889.999 187.856 902.544C178.635 911.053 111.311 883.008 107.717 872.938C105.137 865.709 106.021 852.264 107.479 845.009C109.254 836.184 112.862 825.103 119.655 823.35C124.323 822.146 140.423 835.053 150.63 842.772C157.957 848.313 166.462 856.164 166.462 856.164L167.761 801.765Z",
    fill: "url(#paint62_linear_1348_3000)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.009 813.853C191.811 811.842 191.604 809.832 191.387 807.824C179.982 802.434 171.876 807.054 167.54 811.05L167.366 818.327C169.078 815.8 177.328 805.396 192.009 813.853Z",
    fill: "#EA971D"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.136 884.897C186.955 884.388 187.591 878.338 187.591 878.338C187.591 878.338 172.282 861.199 166.462 856.167C166.462 856.167 157.957 848.316 150.63 842.774C140.424 835.055 124.324 822.148 119.654 823.351C115.319 824.469 112.28 829.393 110.189 835.102C123.145 838.991 141.626 853.847 148.024 858.209C167.319 871.37 182.716 885.579 185.136 884.897Z",
    fill: "url(#paint63_linear_1348_3000)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.61 880.051C187.503 880.052 187.397 880.022 187.3 879.965C187.203 879.907 187.119 879.823 187.052 879.718C186.986 879.614 186.94 879.492 186.917 879.362C186.894 879.232 186.896 879.098 186.922 878.969C189.157 867.733 188.816 823.414 184.912 809.861C184.849 809.642 184.86 809.402 184.94 809.192C185.021 808.983 185.165 808.822 185.341 808.744C185.518 808.667 185.713 808.679 185.883 808.779C186.052 808.878 186.183 809.056 186.247 809.275C190.311 823.38 190.624 867.691 188.297 879.386C188.259 879.576 188.17 879.745 188.045 879.865C187.921 879.986 187.768 880.051 187.61 880.051Z",
    fill: "#EA971D"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.967 885.793C183.257 885.793 179.439 882.872 170.972 876.268C164.553 871.263 156.564 865.035 147.68 858.974C146.457 858.14 144.791 856.923 142.861 855.514C134.559 849.457 120.663 839.318 110.267 836.197C110.177 836.17 110.092 836.121 110.017 836.053C109.942 835.985 109.878 835.899 109.83 835.801C109.782 835.702 109.75 835.593 109.736 835.479C109.721 835.365 109.725 835.249 109.747 835.137C109.77 835.026 109.809 834.92 109.864 834.827C109.919 834.735 109.988 834.656 110.067 834.596C110.147 834.536 110.235 834.497 110.327 834.479C110.419 834.461 110.512 834.466 110.603 834.494C121.203 837.679 135.213 847.901 143.582 854.01C145.503 855.411 147.161 856.621 148.365 857.443C157.286 863.526 165.294 869.77 171.728 874.789C177.986 879.668 183.903 884.287 184.981 884.043C185.862 883.794 186.761 880.485 187.068 878.195C187.083 878.081 187.116 877.972 187.165 877.873C187.214 877.775 187.279 877.69 187.355 877.623C187.431 877.556 187.517 877.508 187.608 877.482C187.699 877.457 187.793 877.454 187.885 877.474C188.271 877.554 188.532 878.002 188.467 878.482C188.319 879.589 187.465 885.14 185.295 885.751C185.187 885.78 185.077 885.794 184.967 885.793Z",
    fill: "#EA971D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1348_3000",
    x1: 1103.97,
    y1: 1218.92,
    x2: 3955.49,
    y2: 3520.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA971D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC6734"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1348_3000",
    x1: 5495.94,
    y1: 16057.1,
    x2: 5495.94,
    y2: 481.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5A8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93778B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1348_3000",
    x1: 11901.9,
    y1: 10508.8,
    x2: 29478.8,
    y2: 32407.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2D265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCBB60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1348_3000",
    x1: 11310.1,
    y1: 9548.53,
    x2: 20626.1,
    y2: 20212.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA971D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9AA4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1348_3000",
    x1: 4422.15,
    y1: 3919.85,
    x2: 12907.8,
    y2: 13863.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE2E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC6734"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1348_3000",
    x1: 7740.89,
    y1: 10362,
    x2: 14562.3,
    y2: 14922.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC6734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA971D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1348_3000",
    x1: 1883.24,
    y1: 1405.64,
    x2: 5046.52,
    y2: 4582.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC6734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA971D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1348_3000",
    x1: 3375.2,
    y1: 3265.9,
    x2: 6382.12,
    y2: 6515.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC6734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA971D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1348_3000",
    x1: 188.584,
    y1: 2055.91,
    x2: 38501.4,
    y2: 2055.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5A8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3173,
    stopColor: "#B3A5AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5783,
    stopColor: "#AC9BA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8186,
    stopColor: "#A08998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93778B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1348_3000",
    x1: 10803.7,
    y1: -9299.18,
    x2: 13768.4,
    y2: 24314.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9AA4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA971D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1348_3000",
    x1: 10813,
    y1: -5985.91,
    x2: 18180.8,
    y2: 26172.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2D265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCBB60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1348_3000",
    x1: 10131.2,
    y1: 6751.65,
    x2: 10131.2,
    y2: 716.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B39057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCBB60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1348_3000",
    x1: -998.84,
    y1: 2481.44,
    x2: 11103.7,
    y2: 6563.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA971D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE4118"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1348_3000",
    x1: 1650.88,
    y1: 3564.35,
    x2: 11700.1,
    y2: 7622.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC6734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1348_3000",
    x1: 548.923,
    y1: 4043.17,
    x2: 5464.11,
    y2: 4043.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B252C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    stopColor: "#572433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4142,
    stopColor: "#4C2346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7018,
    stopColor: "#3B2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241C8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1348_3000",
    x1: 593.197,
    y1: 1627.11,
    x2: 2311.61,
    y2: 1627.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2982,
    stopColor: "#3B2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5858,
    stopColor: "#4C2346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8295,
    stopColor: "#572433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B252C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1348_3000",
    x1: 595.688,
    y1: 1591.48,
    x2: 2993.57,
    y2: 1885.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B252C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    stopColor: "#572433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4142,
    stopColor: "#4C2346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7018,
    stopColor: "#3B2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241C8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1348_3000",
    x1: 618.067,
    y1: 1374.66,
    x2: 2558.51,
    y2: 1374.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2982,
    stopColor: "#3B2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5858,
    stopColor: "#4C2346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8295,
    stopColor: "#572433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B252C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1348_3000",
    x1: 1247.58,
    y1: 1819.12,
    x2: 1247.58,
    y2: 283.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B252C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1171,
    stopColor: "#5B2733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2845,
    stopColor: "#5B2E46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4821,
    stopColor: "#5B3964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7028,
    stopColor: "#5C4890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5C5BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C60D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1348_3000",
    x1: 1483.25,
    y1: 4676.61,
    x2: 1483.25,
    y2: 316.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC6734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA971D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1348_3000",
    x1: 614.232,
    y1: 5176.56,
    x2: 4927.04,
    y2: 5176.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAAEA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3126,
    stopColor: "#E8A89D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7825,
    stopColor: "#E39688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08C7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1348_3000",
    x1: 886.12,
    y1: 1751.18,
    x2: 4636.84,
    y2: 3258.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2421A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#250F50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1348_3000",
    x1: 576.93,
    y1: 4271.27,
    x2: 4228.87,
    y2: 4271.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2421A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1348_3000",
    x1: 544.848,
    y1: 1358.27,
    x2: 4695.79,
    y2: 1358.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2421A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1348_3000",
    x1: 3421.66,
    y1: 5287.6,
    x2: 14421.9,
    y2: 12968.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2421A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#250F50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1348_3000",
    x1: 471.056,
    y1: 1736.31,
    x2: 5443.78,
    y2: 1736.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2421A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1348_3000",
    x1: 561.927,
    y1: 2405.78,
    x2: 3537.22,
    y2: 2405.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE2E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC6734"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1348_3000",
    x1: 1179.2,
    y1: 1820.3,
    x2: 6158.66,
    y2: 6947.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2D265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA971D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1348_3000",
    x1: 403.067,
    y1: 5031.24,
    x2: 6199.72,
    y2: 5031.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4588,
    stopColor: "#F6BCB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAAEA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1348_3000",
    x1: 450.836,
    y1: 3056.36,
    x2: 9385.54,
    y2: 3056.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2421A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1348_3000",
    x1: 1770.27,
    y1: 1367.88,
    x2: 4578.47,
    y2: 3568.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2421A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#250F50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1348_3000",
    x1: 1495.25,
    y1: 161.781,
    x2: 2551.42,
    y2: 2774.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2D265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA971D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1348_3000",
    x1: 629.991,
    y1: 1160.95,
    x2: 2673.22,
    y2: 1160.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895E68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#76474F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7485,
    stopColor: "#622E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B252C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1348_3000",
    x1: 815.445,
    y1: 889.603,
    x2: 6745.76,
    y2: 5758.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE2E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC6734"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1348_3000",
    x1: 980.087,
    y1: 4398.41,
    x2: 3511.85,
    y2: 4046.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2421A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1348_3000",
    x1: 647.311,
    y1: 4509.24,
    x2: 4211.78,
    y2: 4170.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2421A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1348_3000",
    x1: 667.383,
    y1: 3722.77,
    x2: 3823.59,
    y2: 3722.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE2E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC6734"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1348_3000",
    x1: 3840.39,
    y1: 3646.93,
    x2: 3840.39,
    y2: 226.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC6734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA971D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1348_3000",
    x1: 658.456,
    y1: 953.29,
    x2: 2532.5,
    y2: 953.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895E68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B252C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1348_3000",
    x1: 611.689,
    y1: 1761.1,
    x2: 5217.32,
    y2: 1761.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCBB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B39057"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1348_3000",
    x1: 12235.4,
    y1: 5696.96,
    x2: 12235.4,
    y2: 855.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5A8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0376,
    stopColor: "#B3A5AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4026,
    stopColor: "#A18C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7341,
    stopColor: "#977C8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93778B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1348_3000",
    x1: 0,
    y1: 3276.36,
    x2: 3966.64,
    y2: 3276.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93778B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3197,
    stopColor: "#967C90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7176,
    stopColor: "#A08C9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A99BAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1348_3000",
    x1: 4841.74,
    y1: 44332.4,
    x2: 4841.74,
    y2: 464.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895E68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#8D616A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3619,
    stopColor: "#A17174"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6747,
    stopColor: "#AC7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B07D7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1348_3000",
    x1: 5658.89,
    y1: 44332.4,
    x2: 5658.89,
    y2: 464.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895E68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#8D616A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3619,
    stopColor: "#A17174"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6747,
    stopColor: "#AC7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B07D7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1348_3000",
    x1: 170.168,
    y1: 1165.25,
    x2: 7606.63,
    y2: 1165.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B07D7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#AC7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6381,
    stopColor: "#A17174"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945,
    stopColor: "#8D616A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895E68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1348_3000",
    x1: 155.523,
    y1: 1268.42,
    x2: 7764.37,
    y2: 1268.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B07D7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#AC7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6381,
    stopColor: "#A17174"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945,
    stopColor: "#8D616A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895E68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1348_3000",
    x1: 138.664,
    y1: 1346.05,
    x2: 7965.46,
    y2: 1346.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B07D7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#AC7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6381,
    stopColor: "#A17174"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945,
    stopColor: "#8D616A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895E68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1348_3000",
    x1: 120.373,
    y1: 1433.54,
    x2: 8122.54,
    y2: 1433.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B07D7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3253,
    stopColor: "#AC7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6381,
    stopColor: "#A17174"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945,
    stopColor: "#8D616A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895E68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1348_3000",
    x1: 5731.82,
    y1: 44332.4,
    x2: 5731.82,
    y2: 464.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B252C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#5E2930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    stopColor: "#67343B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7672,
    stopColor: "#76464F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895E68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1348_3000",
    x1: 169.118,
    y1: 1126.32,
    x2: 7814.01,
    y2: 1126.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895E68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B252C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1348_3000",
    x1: 154.477,
    y1: 1256.12,
    x2: 7957.92,
    y2: 1256.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895E68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B252C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1348_3000",
    x1: 137.497,
    y1: 1375.07,
    x2: 8171.23,
    y2: 1375.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895E68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B252C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1348_3000",
    x1: 119.039,
    y1: 1504.43,
    x2: 8330.61,
    y2: 1504.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895E68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B252C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1348_3000",
    x1: 4901.33,
    y1: 44332.4,
    x2: 4901.33,
    y2: 464.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B252C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#5E2930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    stopColor: "#67343B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7672,
    stopColor: "#76464F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895E68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1348_3000",
    x1: 116.066,
    y1: 2841.28,
    x2: 4997.07,
    y2: 2841.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAAEA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3126,
    stopColor: "#E8A89D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7825,
    stopColor: "#E39688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08C7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1348_3000",
    x1: 3524.66,
    y1: 6877.65,
    x2: 9270.6,
    y2: 10041.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC6734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1348_3000",
    x1: 61.4499,
    y1: 5771.63,
    x2: 6047.6,
    y2: 5771.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAAEA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3126,
    stopColor: "#E8A89D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7825,
    stopColor: "#E39688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08C7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1348_3000",
    x1: 54.1379,
    y1: 5405.42,
    x2: 7451.48,
    y2: 5405.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B252C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#250F50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1348_3000",
    x1: 111.949,
    y1: 1566.59,
    x2: 1935.71,
    y2: 1566.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2421A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C60D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1348_3000",
    x1: 55.8725,
    y1: 1742.65,
    x2: 5359.24,
    y2: 1742.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C60D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2421A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1348_3000",
    x1: 1767.76,
    y1: 788.488,
    x2: 7399.63,
    y2: 11929.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2421A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#250F50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1348_3000",
    x1: 162.993,
    y1: 3806.84,
    x2: 3513.51,
    y2: 3806.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAAEA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3126,
    stopColor: "#E8A89D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7825,
    stopColor: "#E39688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08C7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1348_3000",
    x1: 2278.01,
    y1: 2273.96,
    x2: 10359,
    y2: 8958.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC6734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1348_3000",
    x1: 110.267,
    y1: 3905.7,
    x2: 7850.42,
    y2: 3905.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA971D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1772C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftware);
export default __webpack_public_path__ + "static/media/software.202501b031b0cfd1749f9c0e3779d7d3.svg";
export { ForwardRef as ReactComponent };